import Image from 'next/image';
import IconThemePrimary from './share_theme_primary.svg?url';
import IconWhite from './share_white.svg?url';
import type { SvgImageProps } from '../types';

export const ShareThemePrimaryImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconThemePrimary} alt={alt} {...props} />;

export const ShareWhiteImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={IconWhite} alt={alt} {...props} />
);
